import React, {useState} from "react";
import {Button} from "../../../../components/Button";
import classNames from "classnames";
import {DgoAdditionalCoverageInfoDialog} from "../Tariffication/VehicleSearch/Dialogs/DgoAdditionalCoverageInfoDialog";
import {strings} from "../../../../strings/strings";

interface VTPLNoOptionComponent {
    error: boolean;
    selected: boolean;
    onSelect: (sumInsured: number, premium: number) => void;
}

export const VTPLNoOptionComponent = ({error, selected, onSelect}: VTPLNoOptionComponent) => {
    const [showDialog, setShowDialog] = useState(false);

    const className = classNames({
        'vtpl-select__options__no-option': true,
        'vtpl-select__options__no-option_error': error,
        'vtpl-select__options__no-option_selected': selected,
    });

    return (
        <div
            className={className}>
            <Button id={className} label={strings.noAdditionalCoverage} onClickListener={() => {
                onSelect(0, 0);
                setShowDialog(true);
            }}/>

            <DgoAdditionalCoverageInfoDialog open={showDialog}
                                             onClose={() => {
                                                 setShowDialog(false);
                                             }}
                                             onConfirm={() => {
                                                 onSelect(undefined, 0);
                                                 setShowDialog(false);
                                             }}/>
        </div>


    )
};